import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // GET CONNECTIONS
  connectionsLoading: true,
  connections: [],
  connectionsError: null,

  // CREATE CONNECTION
  createConnectionLoading: false,
  createConnectionError: null,

  // UPDATE CONNECTION
  updateConnectionLoading: false,
  updateConnectionError: null,

  // UPDATE CONNECTION VEHICLE
  updateConnectionVehicleLoading: false,
  updateConnectionVehicleError: null,

  // UPDATE CONNECTION DRIVER
  updateConnectionDriverLoading: false,
  updateConnectionDriverError: null,

  // DELETE CONNECTION
  deleteConnectionLoading: false,
  deleteConnectionError: null,
};

export const connectionSlice = createSlice({
  name: "connection",
  initialState,
  reducers: {
    // GET CONNECTIONS
    getConnectionsFetch: (state) => {
      state.connectionsLoading = true;
      state.connections = [];
      state.connectionsError = null;
    },
    getConnectionsSuccess: (state, action) => {
      state.connectionsLoading = false;
      state.connections = action.payload;
      state.connectionsError = null;
    },
    getConnectionsError: (state, action) => {
      state.connectionsLoading = false;
      state.connections = [];
      state.connectionsError = action.payload;
    },

    // CREATE CONNECTION
    createConnectionPost: (state) => {
      state.createConnectionLoading = true;
      state.createConnectionError = null;
    },
    createConnectionSuccess: (state) => {
      state.createConnectionLoading = false;
      state.createConnectionError = null;
    },
    createConnectionError: (state, action) => {
      state.createConnectionLoading = false;
      state.createConnectionError = action.payload;
    },

    // UPDATE CONNECTION
    updateConnectionPut: (state) => {
      state.updateConnectionLoading = true;
      state.updateConnectionError = null;
    },
    updateConnectionSuccess: (state) => {
      state.updateConnectionLoading = false;
      state.updateConnectionError = null;
    },
    updateConnectionError: (state, action) => {
      state.updateConnectionLoading = false;
      state.updateConnectionError = action.payload;
    },

    // UPDATE CONNECTION VEHICLE
    updateConnectionVehiclePut: (state) => {
      state.updateConnectionVehicleLoading = true;
      state.updateConnectionVehicleError = null;
    },
    updateConnectionVehicleSuccess: (state) => {
      state.updateConnectionVehicleLoading = false;
      state.updateConnectionVehicleError = null;
    },
    updateConnectionVehicleError: (state, action) => {
      state.updateConnectionVehicleLoading = false;
      state.updateConnectionVehicleError = action.payload;
    },

    // UPDATE CONNECTION DRIVER
    updateConnectionDriverPut: (state) => {
      state.updateConnectionDriverLoading = true;
      state.updateConnectionDriverError = null;
    },
    updateConnectionDriverSuccess: (state) => {
      state.updateConnectionDriverLoading = false;
      state.updateConnectionDriverError = null;
    },
    updateConnectionDriverError: (state, action) => {
      state.updateConnectionDriverLoading = false;
      state.updateConnectionDriverError = action.payload;
    },

    // DELETE CONNECTION
    deleteConnectionDelete: (state) => {
      state.deleteConnectionLoading = true;
      state.deleteConnectionError = null;
    },
    deleteConnectionSuccess: (state) => {
      state.deleteConnectionLoading = false;
      state.deleteConnectionError = null;
    },
    deleteConnectionError: (state, action) => {
      state.deleteConnectionLoading = false;
      state.deleteConnectionError = action.payload;
    },
  },
});

export const connectionActions = connectionSlice.actions;
export const connectionReducers = connectionSlice.reducer;
